import Home from './src/Home.vue'
import Task from './src/Task.vue'
import TaskInfo from './src/TaskInfo.vue'
import Abnormal from './src/Abnormal.vue'

let views = {
    Home,
    Task,
    Abnormal,
    TaskInfo
};

export default views;